/* ATAS scroll film — plays two image sequences on a canvas as the visitor scrolls.
   Sequence B (360° turn) plays first, crossfades into sequence A (pour).
   Frames load lazily (coarse → fine) only when the section approaches the viewport. */
(function () {
  if (window.__atxFilm) return;
  window.__atxFilm = true;
  var clamp = function (v) { return Math.min(1, Math.max(0, v)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var B_END = 0.4, A_START = 0.46;

  function urls(first, count) {
    var base = first.split('?')[0];
    var out = [];
    for (var i = 1; i <= count; i++) out.push(base.replace(/-001\.jpg$/, '-' + ('00' + i).slice(-3) + '.jpg'));
    return out;
  }

  function Film(root) {
    this.root = root;
    this.canvas = root.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    this.bar = root.querySelector('[data-bar]');
    this.cta = root.querySelector('[data-cta]');
    this.size = window.innerWidth < 750 ? 'm' : 'd';
    this.a = urls(root.getAttribute('data-a-' + this.size), +root.getAttribute('data-a-count')).map(function (u) { return { u: u, img: null, ok: false }; });
    this.b = urls(root.getAttribute('data-b-' + this.size), +root.getAttribute('data-b-count')).map(function (u) { return { u: u, img: null, ok: false }; });
    this.loading = false;
    this.last = -1;
    this.resize();
  }

  Film.prototype.load = function () {
    if (this.loading) return;
    this.loading = true;
    var self = this, queue = [], seen = {};
    [16, 8, 4, 2, 1].forEach(function (stride) {
      [self.b, self.a].forEach(function (seq, s) {
        for (var i = 0; i < seq.length; i += stride) { var k = s + ':' + i; if (!seen[k]) { seen[k] = 1; queue.push(seq[i]); } }
      });
    });
    var active = 0, MAX = 6;
    function next() {
      while (active < MAX && queue.length) {
        (function (f) {
          active++;
          var img = new Image();
          img.decoding = 'async';
          img.onload = function () { f.ok = true; active--; self.last = -1; self.draw(); next(); };
          img.onerror = function () { active--; next(); };
          img.src = f.u; f.img = img;
        })(queue.shift());
      }
    }
    next();
  };

  Film.prototype.resize = function () {
    var r = this.canvas.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.canvas.width = Math.max(1, Math.round(r.width * dpr));
    this.canvas.height = Math.max(1, Math.round(r.height * dpr));
    this.last = -1;
  };

  Film.prototype.frame = function (seq, idx) {
    if (seq[idx] && seq[idx].ok) return seq[idx].img;
    for (var d = 1; d < seq.length; d++) {
      if (seq[idx - d] && seq[idx - d].ok) return seq[idx - d].img;
      if (seq[idx + d] && seq[idx + d].ok) return seq[idx + d].img;
    }
    return null;
  };

  Film.prototype.paint = function (img, alpha) {
    if (!img) return;
    var c = this.canvas, cw = c.width, ch = c.height, iw = img.naturalWidth, ih = img.naturalHeight;
    var s = Math.max(cw / iw, ch / ih), w = iw * s, h = ih * s;
    this.ctx.globalAlpha = alpha;
    this.ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    this.ctx.globalAlpha = 1;
  };

  Film.prototype.progress = function () {
    var r = this.root.getBoundingClientRect(), total = r.height - window.innerHeight;
    return total <= 0 ? 1 : clamp(-r.top / total);
  };

  Film.prototype.draw = function () {
    var p = reduce ? 1 : this.progress();
    if (Math.abs(p - this.last) < 0.0004) return;
    this.last = p;
    var nb = this.b.length - 1, na = this.a.length - 1;
    this.ctx.fillStyle = '#0a0a0b';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    if (p <= B_END) {
      this.paint(this.frame(this.b, Math.round(p / B_END * nb)), 1);
    } else if (p < A_START) {
      var t = (p - B_END) / (A_START - B_END);
      this.paint(this.frame(this.b, nb), 1);
      this.paint(this.frame(this.a, 0), t);
    } else {
      this.paint(this.frame(this.a, Math.round((p - A_START) / (1 - A_START) * na)), 1);
    }
    if (this.frame(this.b, 0)) this.root.classList.add('is-ready');

    var active = 0;
    for (var i = 0; i < this.steps.length; i++) if (p >= parseFloat(this.steps[i].getAttribute('data-at') || 0)) active = i;
    for (var j = 0; j < this.steps.length; j++) {
      this.steps[j].classList.toggle('is-active', j === active);
      this.steps[j].classList.toggle('is-done', j < active);
    }
    if (this.bar) this.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    if (this.cta) this.cta.classList.toggle('is-in', p > 0.9);
  };

  var films = [], ticking = false;
  function tick() { ticking = false; for (var i = 0; i < films.length; i++) films[i].draw(); }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(tick); } }
  function init() {
    films = Array.prototype.map.call(document.querySelectorAll('[data-atx-film]'), function (r) { return new Film(r); });
    if (reduce) document.documentElement.classList.add('atx-reduce');
    films.forEach(function (f) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { f.load(); io.disconnect(); } }, { rootMargin: '150% 0px' });
        io.observe(f.root);
      } else f.load();
    });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', function () { films.forEach(function (f) { f.resize(); }); request(); }, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
